<template>
    <hts-drawer
        v-model="visible"
        :title="$t('labels.viewDetail')"
        size="large"
        @close="closeOverSide"
        @loaded="getData">
        <div>
            <hts-card :title="$t('labels.generalInformation')">
                <div
                    v-if="dataFormEditVehicle.type === 1"
                    class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                    <hts-select-cooperator
                        v-model="dataFormEditVehicle.fleetVehicle"
                        :name="dataFormEditVehicle.fleetVehicleDetail.name"
                        readonly
                        prop="fleetVehicle"
                        type-cooperator="PARTNER,VENDOR"
                        :label="$t('labels.fleetVehicle')" />
                    <hts-form-input
                        v-model="dataFormEditVehicle.licensePlate"
                        :label="$t('labels.vehicleModule.licensePlate')"
                        readonly
                        :color="props.color"
                        name="vehicleModule.licensePlate"
                        prop="vehicleModule.licensePlate" />
                </div>
                <template v-if="dataFormEditVehicle.type === 0">
                    <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                        <div class="flex">
                            <hts-form-checkbox
                                v-model="dataFormEditVehicle.containerType"
                                readonly
                                :items="[{ label: $t('labels.vehicleModule.containerType'), value: false }]" />
                            <hts-tooltip class="mt-1">
                                <div>
                                    <span class="font-bold">
                                        {{ $t('labels.containerTypeDetail') }}
                                    </span>
                                </div>
                                <template #reference>
                                    <hi-information-circle-icon class="flex items-center text-green-500 w-6 h-6" />
                                </template>
                            </hts-tooltip>
                        </div>

                        <hts-form-checkbox
                            v-model="dataFormEditVehicle.isGenset"
                            readonly
                            :items="[{ label: $t('labels.vehicleModule.useGenset'), value: false }]" />

                        <hts-form-input
                            v-model="dataFormEditVehicle.licensePlate"
                            :label="$t('labels.vehicleModule.licensePlate')"
                            readonly
                            :color="props.color"
                            name="vehicleModule.licensePlate"
                            prop="vehicleModule.licensePlate" />

                        <hts-form-input
                            v-model="dataFormEditVehicle.manufacture"
                            :label="$t('labels.vehicleModule.manufacture')"
                            readonly
                            :color="props.color"
                            name="vehicleModule.manufacture"
                            prop="vehicleModule.manufacture" />

                        <hts-form-input
                            v-model="dataFormEditVehicle.vehicleLoad"
                            :label="$t('labels.vehicleModule.category.vehicleLoad')"
                            :color="props.color"
                            readonly
                            type="number"
                            name="vehicleModule.category.vehicleLoad"
                            prop="vehicleModule.category.vehicleLoad">
                            <template #custom>
                                <hts-tooltip>
                                    <div>
                                        <span class="font-bold">
                                            {{ $t('labels.vehicleModule.subcriptionVehicleLoad') }}
                                        </span>
                                    </div>
                                    <template #reference>
                                        <hi-information-circle-icon class="flex items-center text-green-500 w-6 h-6" />
                                    </template>
                                </hts-tooltip>
                            </template>
                        </hts-form-input>

                        <hts-form-input
                            v-model="dataFormEditVehicle.weight"
                            :label="$t('labels.vehicleModule.weight')"
                            type="number"
                            readonly
                            :color="props.color"
                            name="vehicleModule.weight"
                            prop="vehicleModule.weight" />

                        <hts-form-input
                            v-model="dataFormEditVehicle.expiredYear"
                            :label="$t('labels.vehicleModule.expiredYear')"
                            readonly />

                        <hts-form-input
                            v-model="dataFormEditVehicle.price"
                            :label="$t('labels.vehicleModule.price')"
                            readonly
                            type="number"
                            :color="props.color"
                            name="vehicleModule.price"
                            prop="vehicleModule.price" />

                        <hts-form-input
                            v-model="dataFormEditVehicle.buyingTime"
                            :label="$t('labels.vehicleModule.buyingTime')"
                            readonly />

                        <hts-form-input
                            v-model="dataFormEditVehicle.licenseType"
                            :label="$t('labels.driverModule.licenseType')"
                            readonly />

                        <div>
                            <hts-form-input
                                v-model="dataFormEditVehicle.driverName"
                                :label="$t('labels.primaryDriver')"
                                readonly />
                            <hts-form-input
                                v-model="dataFormEditVehicle.coDriverName"
                                :label="$t('labels.coDriver')"
                                readonly />
                        </div>

                        <hts-form-input
                            v-model="dataFormEditVehicle.parkingNodeName"
                            :label="$t('labels.parkingLot')"
                            readonly />

                        <hts-select-tracking-gps
                            v-model="dataFormEditVehicle.gpsTrackingType"
                            readonly
                            prop="gpsTrackingType"
                            name="gpsTrackingType"
                            :label="$t('labels.gpsTrackingType')" />
                    </div>
                </template>
            </hts-card>
            <div
                v-if="dataFormEditVehicle.type === 0"
                class="mt-1.5">
                <hts-card :title="$t('labels.vehicleModule.tollStationInformation')">
                    <div class="color-theme size-default hts-form-input">
                        <div
                            v-if="dataFormEditVehicle.tollStation && dataFormEditVehicle.tollStation.length > 0"
                            class="grid grid-cols-1 gap-4 my-3">
                            <div
                                v-for="(item, index) in dataFormEditVehicle.tollStation"
                                :key="index">
                                <hts-form-disclosure
                                    color="main"
                                    size="large"
                                    :is-have-children="false"
                                    :is-have-remove-icon="true"
                                    readonly>
                                    <template #reference>
                                        <div class="grid grid-cols-1">
                                            <span class="mt-2 text-base">
                                                {{ $t('labels.vehicleModule.tollStationName') }}: {{ item?.tollStationDetail?.location?.locationName }}
                                            </span>
                                            <span class="mt-2 text-base">
                                                {{ $t('labels.calculatedBy') }}:
                                                {{ item.calculatedBy === 'MONTH' ? $t('labels.month') : item.calculatedBy === 'QUARTER' ? $t('labels.quarter') : '' }}
                                            </span>
                                            <span class="mt-2 text-base">
                                                {{ $t('labels.from') }}: {{ $formatters.date(item.from || 0) }}
                                            </span>
                                            <span class="mt-2 text-base">
                                                {{ $t('labels.to') }}: {{ $formatters.date(item.to || 0) }}
                                            </span>
                                        </div>
                                    </template>
                                </hts-form-disclosure>
                            </div>
                        </div>
                    </div>
                    <toll-station
                        :show-popup-add-toll-station="openPopupTollStation"
                        :vehicle-is-selected="dataFormEditVehicle"
                        @submitTollStation="(data:any, value:string)=>handleAddTollStation(data, value)"
                        @close="openPopupTollStation = false" />
                    <!-- @add="handleAddVehicleCategory" -->
                </hts-card>
                <hts-card
                    v-if="checkPermission(layoutPermissions.vehicle_administration)"
                    :title="$t('labels.vehicleModule.administration')">
                    <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                        <hts-form-input
                            v-model="dataFormEditVehicle.fuelConsumption"
                            :label="$t('labels.vehicleModule.fuelConsumption')"
                            type="number"
                            readonly
                            :color="props.color"
                            name="vehicleModule.fuelConsumption"
                            prop="vehicleModule.fuelConsumption" />
                        <hts-form-input
                            v-model="dataFormEditVehicle.priceLiquidation"
                            :label="$t('labels.priceLiquidation')"
                            type="number"
                            readonly
                            :color="props.color"
                            name="priceLiquidation"
                            prop="priceLiquidation" />
                        <div>
                            <hts-form-input
                                v-model="dataFormEditVehicle.depreciationVehicle"
                                :label="$t('labels.vehicleModule.depreciationVehicle')"
                                type="number"
                                readonly
                                :color="props.color"
                                name="vehicleModule.depreciationVehicle"
                                prop="vehicleModule.depreciationVehicle"
                                @change="updateDepreciationVehicle(true)" />
                            <p class="text-error-500 text-xs p-0 m-0 ml-1">
                                {{ showVehicleDepreciationError ? $t('labels.vehicleModule.vehicleDepreciationError') : '' }}
                            </p>
                        </div>
                        <hts-form-input
                            v-model="dataFormEditVehicle.repairingPrice"
                            :label="$t('labels.vehicleModule.repairingPrice')"
                            type="number"
                            readonly
                            :color="props.color"
                            name="repairingPrice"
                            prop="repairingPrice" />
                    </div>
                </hts-card>
            </div>
        </div>

        <hts-card
            v-if="dataFormEditVehicle.type === 1"
            :title="$t('labels.driverInfo')">
            <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                <hts-form-input
                    v-model="dataFormEditVehicle.otherCompanyDriver.fullName"
                    :label="$t('labels.fullName')"
                    :color="color"
                    readonly
                    name="fullName"
                    prop="fullName" />
                <hts-form-phone
                    v-model="dataFormEditVehicle.otherCompanyDriver.phone"
                    :label="$t('labels.phone')"
                    prop="phone"
                    name="phone"
                    readonly
                    @updateCode="(val) => (dataFormEditVehicle.otherCompanyDriver.phone.code = val)" />
                <hts-form-input
                    v-model="dataFormEditVehicle.otherCompanyDriver.idCardNumber"
                    :label="$t('labels.idCardNumber')"
                    :color="color"
                    readonly
                    name="idCardNumber"
                    prop="idCardNumber" />
            </div>
        </hts-card>

        <AddTollStation
            ref="addTollStation"
            @submit="handleAddTollStation" />
        <hts-modal
            v-model="modalConfirmDepreciationVehicle"
            :title="$t('labels.vehicleModule.vehicleDepreciationConfirm')"
            :content="$t('labels.vehicleModule.vehicleDepreciationConfirmDetail')"
            type="confirm"
            @confirm="modalConfirmDepreciationVehicle = false"
            @hide="cancelDepreciationVehicle" />
    </hts-drawer>
</template>

<script setup lang="ts">
import AddTollStation from './add-toll-station.vue'
import form, { IVehicle } from './imports/form'
import { $api, $lodash } from '#imports'
import layoutPermissions from '@/data/permissions/layout-permissions'
import data from '@/pages/trucker-[id]/driver/ignore/imports/data'
import { checkPermission } from '@/utils/permission-check'

const { $formatters } = useNuxtApp()
const { rules } = form
const store = $store()
const { license } = data()

const route = useRoute()
const id: string = route.query.id ? String(route.query.id) : ''

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 3
  }
})

const emits = defineEmits(['close', 'refreshDataTables'])

const dataFormEditVehicle = reactive<IVehicle>({ ...form.initFormVehicle } as IVehicle)
const visible = ref(false)
const openPopupTollStation = ref(false)
const openPopupAddCategory = ref(false)
const modalConfirmDepreciationVehicle = ref(false)
const closeOverSide = () => {
  visible.value = false
  emits('close')
}

const configCont: { [key: string]: any } = reactive({})

const openEditVehicle = async (vehicleId: string) => {
  visible.value = true
  loading.value = true
  Object.assign(dataFormEditVehicle, { ...form.initFormVehicle })
  await getData(vehicleId)
  if (dataFormEditVehicle.type === 1) {
    await getDataCooperator()
  }
  Object.assign(configCont, store.globalSettings.getGlobalSettings.configCont || {})
  if (dataFormEditVehicle.type === 0 || (dataFormEditVehicle.typeFleetVehicle && dataFormEditVehicle.typeFleetVehicle.includes('PARTNER'))) {
    handleInputVehicleLoad(dataFormEditVehicle.vehicleLoad)
  }
  nextTick(() => {
    loading.value = false
  })
}
defineExpose({
  openEditVehicle
})

const loading = ref(false)

const getData = async (id: string | undefined | String) => {
  const api = $url.vehicle.vehicle.getById
  await $api(api, { uriParams: { ID: id } }).then((data: any) => {
    const resData: any = data.data.value
    if (resData.success) {
      Object.assign(dataFormEditVehicle, resData.data)
      defaultValueVehicle()
    }
  })
}

const defaultValueVehicle = () => {
  if ($lodash.isNil(dataFormEditVehicle.vehicleTypeDetail)) {
    dataFormEditVehicle.vehicleTypeDetail = {}
  }
  if ($lodash.isNil(dataFormEditVehicle.containerType) || !dataFormEditVehicle.containerType) {
    dataFormEditVehicle.containerType = false
    dataFormEditVehicle.goodsType = ['SOLID']
  }
  if ($lodash.isNil(dataFormEditVehicle.isGenset)) {
    dataFormEditVehicle.isGenset = false
  }

  // nếu management đã duyệt lấy giá trị đã lưu, chưa duyệt lấy giá trị bên loại xe
  dataFormEditVehicle.fuelConsumption = dataFormEditVehicle?.approvedByManagement
    ? dataFormEditVehicle?.fuelConsumption
    : dataFormEditVehicle?.vehicleTypeDetail?.oilMaterialAssumption

  dataFormEditVehicle.priceLiquidation = dataFormEditVehicle?.approvedByManagement
    ? dataFormEditVehicle?.priceLiquidation
    : dataFormEditVehicle?.vehicleTypeDetail?.liquidationValue

  dataFormEditVehicle.repairingPrice = dataFormEditVehicle?.approvedByManagement
    ? dataFormEditVehicle?.repairingPrice
    : dataFormEditVehicle?.vehicleTypeDetail?.repairingPrice
}

const handleInputVehicleLoad = $lodash.debounce((value: number | null) => {
  const api = $urlAdmin.vehicle.category['find-by-vehicle-tonnage']
  $api(api, {
    uriParams: { KEY: typeof value === 'number' ? value : typeof dataFormEditVehicle.vehicleLoad === 'number' ? dataFormEditVehicle.vehicleLoad : '' }
  }).then((data: any) => {
    const resData: any = data.data?.value
    if (resData?.success) {
      if (resData.data) {
        vehicleCategory.value = resData.data || {}
        dataFormEditVehicle.vehicleType = resData.data._id || ''
        if (!dataFormEditVehicle.approvedByManagement) {
          dataFormEditVehicle.repairingPrice = resData.data.repairingPrice || 0
          dataFormEditVehicle.priceLiquidation = resData.data.liquidationValue || 0
          dataFormEditVehicle.fuelConsumption = resData.data.oilMaterialAssumption || 0
          dataFormEditVehicle.repairingPrice = resData.data.repairingPrice || 0
        }
      } else if (!$lodash.isNil(dataFormEditVehicle.vehicleLoad)) {
        openPopupAddCategory.value = true
        vehicleCategory.value = {}
      }
    }
  })
}, 500)

const updateDepreciationVehicle = $lodash.debounce((depreciationVehicle?: Boolean) => {
  if (depreciationVehicle) {
    depreciationVehicleChange()
    return
  }

  if (!dataFormEditVehicle?.buyingTime || !dataFormEditVehicle?.expiredYear) {
    dataFormEditVehicle.depreciationVehicle = 1
    return
  }
  dataFormEditVehicle.depreciationVehicle = Number(dataFormEditVehicle.expiredYear) - Number(dataFormEditVehicle.buyingTime)
  if (dataFormEditVehicle.depreciationVehicle < 1) {
    dataFormEditVehicle.depreciationVehicle = 1
  }
}, 500)

const handleOpenPopupTollStation = () => {
  if (addTollStation.value) {
    addTollStation.value.open()
  }
}
const handleAddTollStation = (data: any, value: string, index: number) => {
  if (!(typeof index === 'number')) {
    data.newTollStation = true
    dataFormEditVehicle.tollStation.push(data)
  }
  if (typeof index === 'number') {
    Object.assign(dataFormEditVehicle.tollStation[index], { ...data })
  }
}
const handleRemove = (index: number) => {
  dataFormEditVehicle.tollStation.splice(index, 1)
}

const handleSubmitFormEditVehicle = async () => {
  if (dataFormEditVehicle.type === 0 && !Object.keys(vehicleCategory.value).length) {
    openPopupAddCategory.value = true
    return
  }
  const api = $url.vehicle.vehicle.edit

  if (!dataFormEditVehicle.containerType) {
    dataFormEditVehicle.goodsType = []
    dataFormEditVehicle.coveringContainerLevel = ''
  }

  const data: any = await $api(api, {
    uriParams: { ID: dataFormEditVehicle._id },
    body: { ...dataFormEditVehicle }
  })
  const resData: any = data?.data?.value
  if (resData.success) {
    process.client && $toast().success(resData.data)
    emits('refreshDataTables')
    emits('close')
    visible.value = false
  }
}

const vehicleCategory = ref({})

const showVehicleDepreciationError = computed(() => {
  if (!checkPermission(layoutPermissions.vehicle_administration)) {
    return false
  }

  const depreciationVehicle = Number(dataFormEditVehicle.expiredYear) - Number(dataFormEditVehicle.buyingTime)
  if (depreciationVehicle < 1) {
    return false
  }

  if (dataFormEditVehicle.depreciationVehicle && dataFormEditVehicle.depreciationVehicle < 1) {
    return false
  }

  if (depreciationVehicle < Number(dataFormEditVehicle.depreciationVehicle)) {
    return true
  }
  return false
})

const addTollStation = ref()

const depreciationVehicleChange = () => {
  if (!checkPermission(layoutPermissions.vehicle_administration)) {
    return
  }
  const expiredYear = Number(dataFormEditVehicle.expiredYear) || undefined
  const buyingTime = Number(dataFormEditVehicle.buyingTime) || undefined
  const depreciationVehicle = Number(dataFormEditVehicle.depreciationVehicle) || undefined

  if (typeof expiredYear !== 'number' || typeof buyingTime !== 'number' || typeof depreciationVehicle !== 'number') {
    return
  }
  if (depreciationVehicle > 0 && depreciationVehicle < expiredYear - buyingTime) {
    modalConfirmDepreciationVehicle.value = true
  }
}

const cancelDepreciationVehicle = $lodash.debounce(() => {
  const expiredYear = Number(dataFormEditVehicle.expiredYear) || 0
  const buyingTime = Number(dataFormEditVehicle.buyingTime) || 0
  dataFormEditVehicle.depreciationVehicle = expiredYear - buyingTime || 1
})

const getDataCooperator = async () => {
  const api = $url.partner['get-detail']
  await $api(api, { uriParams: { ID: dataFormEditVehicle.fleetVehicle } })
    .then((data: any) => {
      const resData: any = data.data.value
      if (resData.success) {
        dataFormEditVehicle.typeFleetVehicle = resData.data.type
      }
    })
    .catch(() => {
      visible.value = false
    })
}

const findDrivers = async (s: string) => {
  const api: any = $url.driver.driver.selectByLicenseType

  const res = await $api(api, {
    query: {
      key: s,
      licenseType: dataFormEditVehicle.licenseType
    }
  })
  const resData: any = res?.data.value
  if (resData.success) {
    return resData.data
  }
  return null
}
const showDrawerAddVehicleCategory = ref()
const openAddCategory = () => {
  if (showDrawerAddVehicleCategory.value) {
    openPopupAddCategory.value = false
    showDrawerAddVehicleCategory.value.openAddCategory()
  }
}
</script>
